import React, { Component } from 'react'
import { Button, Card, Table, Pagination, Modal, Input } from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'
import { API_GET_USER_EVENTS } from './../../../api'

import './events.css'

const columns = [
  {
    title: 'Events',
    dataIndex: 'event',
    key: 'event',
  },
  {
    title: 'Device name',
    dataIndex: 'device',
    key: 'device',
  },
  {
    title: 'Apps',
    dataIndex: 'appVersion',
    key: 'appVersion',
  },
  {
    title: 'IP',
    dataIndex: 'ip',
    key: 'ip',
  },
  {
    title: 'TImestamp',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: text => (
      <div>
        <div className="block">{moment(text).format('DD MMM YYYY, HH:mm')}</div>
      </div>
    ),
  },
]

class Events extends Component {
  constructor(props) {
    super(props)
    this.state = {
      events: [],
      dataCount: 0,
      currentPage: 1,
      isNoteModalVisible: false,
      noteText: '',
      userNotes: [],
    }
  }

  componentDidMount() {
    console.log('Component mounted with userId:', this.props.userId)
    API_GET_USER_EVENTS(this.props.userId).then(res =>
      this.setState({
        ...this.state,
        events: res.data.userEvents,
        dataCount: res.data.count,
      }))
    this.loadUserNotes()
  }

  loadUserNotes = () => {
    console.log('Loading notes for userId:', this.props.userId)
    const notes = localStorage.getItem(`user_notes_${this.props.userId}`)
    if (notes) {
      this.setState({ userNotes: JSON.parse(notes) })
    }
  }

  showNoteModal = () => {
    console.log('Opening note modal')
    this.setState({ isNoteModalVisible: true })
  }

  handleNoteCancel = () => {
    console.log('Canceling note')
    this.setState({ isNoteModalVisible: false, noteText: '' })
  }

  handleNoteChange = (e) => {
    this.setState({ noteText: e.target.value })
  }

  handleNoteSave = () => {
    console.log('Saving note')
    const { noteText, userNotes } = this.state
    if (noteText.trim()) {
      const newNote = {
        id: Date.now(),
        text: noteText,
        timestamp: new Date().toISOString(),
      }
      const updatedNotes = [...userNotes, newNote]
      this.setState({ 
        userNotes: updatedNotes,
        isNoteModalVisible: false,
        noteText: ''
      })
      localStorage.setItem(`user_notes_${this.props.userId}`, JSON.stringify(updatedNotes))
    }
  }

  changePage = (page) => {
    API_GET_USER_EVENTS(this.props.userId, { page }).then(res =>
      this.setState({
        ...this.state,
        events: res.data.userEvents,
        dataCount: res.data.count,
        currentPage: page,
      }))
  }

  render() {
    const { events, dataCount, currentPage, isNoteModalVisible, noteText, userNotes } = this.state
    console.log('Current state:', { isNoteModalVisible, noteText, userNotes })
    
    return (
      <div>
        <Card className="table-responsive">
          <div>
            <Table
              dataSource={events}
              columns={columns}
              rowKey="id"
              pagination={false}
            />
            <div className="app-pagination">
              <Pagination
                current={currentPage}
                total={dataCount}
                onChange={this.changePage}
              />
            </div>
          </div>
        </Card>

        <br />

        <Card className="event-latest">
          <div>
            <p>Latest Events for this User</p>
            <hr />
            {userNotes.map(note => (
              <div key={note.id} className="note-item">
                <div>{note.text}</div>
                <small>{moment(note.timestamp).format('DD MMM YYYY, HH:mm')}</small>
              </div>
            ))}
          </div>
        </Card>

        <br />
        <div>
          <Button 
            type="primary"
            className="event-btn-note" 
            onClick={this.showNoteModal}
          >
            Add Note
          </Button>
        </div>

        <Modal
          title="Add Note"
          visible={isNoteModalVisible}
          onOk={this.handleNoteSave}
          onCancel={this.handleNoteCancel}
          okText="Save"
          cancelText="Cancel"
        >
          <Input.TextArea
            rows={4}
            value={noteText}
            onChange={this.handleNoteChange}
            placeholder="Enter your note here..."
          />
        </Modal>
      </div>
    )
  }
}

Events.defaultProps = {
  userId: 0,
}

Events.propTypes = {
  userId: PropTypes.string,
}

export default Events




// WEBPACK FOOTER //
// src/pages/user/events/index.js